import { connect } from "react-redux";

import GlobalChangeOverTimeChart from "../../components/visualizations/global_change_over_time_chart";
import { onExportDefault } from "../../actions/slide_decks";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainChart)) { return {}; }

  const dataAndOptions = ld.mainChart;
  const countryName = state.main.filters.country.selectedValue ? state.main.filters.country.selectedValue.value : null;
  const title = `Tariffs over time by city: ${countryName} ${ld.minYear}-${ld.maxYear}`;
  const showExportButton = !state.main.slideDecks.slideDeckBeingSaved;

  return { dataAndOptions, title, showExportButton };
};

const mapDispatchToProps = dispatch => ({
  exportChart: onExportDefault(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalChangeOverTimeChart);
